import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_My_header = _resolveComponent("My-header");

  const _component_router_view = _resolveComponent("router-view");

  const _component_My_footer = _resolveComponent("My-footer");

  const _component_el_config_provider = _resolveComponent("el-config-provider");

  return _openBlock(), _createBlock(_component_el_config_provider, {
    locale: _ctx.messages[_ctx.locale]
  }, {
    default: _withCtx(() => [_createVNode(_component_My_header), _createVNode(_component_router_view), _createVNode(_component_My_footer)]),
    _: 1
  }, 8, ["locale"]);
}